<template>
  <div>
    <sidebar-menu :title="'CONTRACTS'" />

    <div class="container-fluid my-3">
      <div class="row">
        <div class="col-10 col-sm-11">
          <div class="h-100">
            <ol class="breadcrumb my-auto" v-if="breadcrumbItems.length > 0">
              <li
                v-for="(breadcrumb, index) in breadcrumbItems"
                :key="index"
                class="breadcrumb-item"
                :class="{'active font-weight-bold': index == (breadcrumbItems.length -1)}"
                @click="navigate(breadcrumb)"
              >
                <a
                  class="black-text"
                  :class="{'pointer': index != (breadcrumbItems.length - 1) }"
                >{{breadcrumb.split(/(?=[A-Z])/).join(" ")}}</a>
                <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
              </li>
            </ol>
          </div>
        </div>

        <div class="col-2 col-sm-1">
          <div class="float-right mt-2">
            <span>
              <a class="close">
                <i class="far fa-times-circle fa-2x" aria-label="Close" @click="closePanel"></i>
              </a>
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div id="panel-content-container" class="container-fluid slide_out_container no-pad mt-4">
            <contract v-if="activeSection === 'Contract'" />
            <service v-if="activeSection === 'GasService'" />
            <service v-if="activeSection === 'ElectricityService'" />
            <service v-if="activeSection === 'CommercialConfig'" />
            <service-bundle v-if="activeSection === 'ServiceBundle'" />
            <priority-service-set v-if="activeSection === 'PriorityServiceSet'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";

// Components
import SidebarMenu from "../sidebar-components/ContractsSidebar";
import Contract from "./views/Contract";
import ServiceBundle from "./views/ServiceBundle";
import Service from "./views/Service";
import PriorityServiceSet from "./views/PriorityServiceSet";

// Mixins
import contractsMixin from "@/mixins/contracts/contracts";

export default {
  name: "contractsPanel",
  mixins: [contractsMixin],
  components: {
    SidebarMenu,
    Contract,
    ServiceBundle,
    Service,
    PriorityServiceSet,
  },
  created() {
    this.navigate("Contract");
  },
  computed: {
  },
  methods: {
    orderByEffectiveFrom(collection) {
      return this.$_.sortBy(collection, function (item) {
        return item.EffectiveFrom;
      }).reverse();
    },
    closePanel() {
      this.$emit("closePanel");
    },
    shortDate(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    formatItem(item) {
      return item.split(/(?=[A-Z])/).join(" ");
    },
    onCollapse(collapsed) {
      const container = document.getElementById("panel-content-container");
      if (collapsed) {
        container.style.paddingLeft = "100px";
        container.style.paddingRight = "50px";
      } else {
        container.style.paddingLeft = "365px";
        container.style.paddingRight = "15px";
      }
    },
    navigate(section) {
      this.activeSection = section;
      if (section === "Contract") {
        this.breadcrumbItems = ["Contract"];
        this.activeService = null;
        this.activeBundle = null;
        this.activeCommercialConfig = null;
      }
      if (section === "ServiceBundle") {
        this.breadcrumbItems = ["Contract", "ServiceBundle"];
        this.activeService = null;
        this.activeCommercialConfig = null;
      }
      if (section === "GasService") {
        this.breadcrumbItems = ["Contract", "GasService"];
        this.activeCommercialConfig = null;
      }
      if (section === "ElectricityService") {
        this.breadcrumbItems = ["Contract", "ElectricityService"];
        this.activeCommercialConfig = null;
      }
    },
  },
  onMenuItemClick(event, item) {
    this.$store.commit("resetEditModes");
    if (item.hasOwnProperty("contracts")) {
      this.activeSection = "Contracts";
      this.breadcrumbItems = ["Contracts"];
    }
    if (item.hasOwnProperty("contract")) {
      this.activeSection = "Contract";
      this.breadcrumbItems = ["Contracts", "Contract"];
      this.activeContract = item.contract;
      this.activeBundle = null;
      this.activeService = null;
    }
    if (item.hasOwnProperty("serviceBundles")) {
      this.activeSection = "ServiceBundles";
      this.breadcrumbItems = ["Contracts", "Contract", "ServiceBundles"];
    }
    if (item.hasOwnProperty("serviceBundle")) {
      this.activeSection = "ServiceBundle";
      this.breadcrumbItems = [
        "Contracts",
        "Contract",
        "ServiceBundles",
        "ServiceBundle",
      ];
      this.activeBundle = item.serviceBundle;
      this.activeService = this.orderByEffectiveFrom(
        this.activeContract.Services
      )[0];
    }
    if (item.hasOwnProperty("services")) {
      if (item.serviceType == "Gas") {
        this.activeSection = "GasServices";
        this.breadcrumbItems = ["Contracts", "Contract", "GasServices"];
      }
      if (item.serviceType == "Electricity") {
        this.activeSection = "ElectricServices";
        this.breadcrumbItems = ["Contracts", "Contract", "ElectricServices"];
      }
    }
    if (item.hasOwnProperty("service")) {
      if (item.serviceType == "Gas") {
        this.activeSection = "GasService";
        this.breadcrumbItems = [
          "Contracts",
          "Contract",
          "GasServices",
          "GasService",
        ];
      }
      if (item.serviceType == "Electricity") {
        this.activeSection = "ElectricService";
        this.breadcrumbItems = [
          "Contracts",
          "Contract",
          "ElectricServices",
          "ElectricService",
        ];
      }
      this.activeService = item.service;
    }
    if (item.hasOwnProperty("priorityServiceSets")) {
      this.activeSection = "PriorityServiceSets";
      this.breadcrumbItems = ["Contracts", "Contract", "PriorityServiceSets"];
    }
    if (item.hasOwnProperty("priorityServiceSet")) {
      this.activeSection = "PriorityServiceSet";
      this.breadcrumbItems = [
        "Contracts",
        "Contract",
        "PriorityServiceSets",
        "PriorityServiceSet",
      ];
      this.activePSRSet = item.priorityServiceSet;
    }
  },
};
</script>